import { isArray } from 'lodash'

export default {
  getCents(price) {
    if (!price && price !== 0) return ''
    return parseFloat(price).toFixed(2)
  },
  isLibrary(code) {
    if (!code) return false

    const customer = localStorage.getItem('customerCode')
    if (isArray(code)) return code.includes(customer)

    const codeArray = code.split(',')
    const isInLibrary = codeArray.includes(customer)
    return isInLibrary
  },
  isLastItem(pageNumber, itemList) {
    if (!pageNumber) return false
    return itemList.length === 1
  },
}
